const PhoneNumberFormats = {
  US: [/(\d{3})(\d{0,3})(\d{0,4})/g, '($1) $2-$3'],
  US1: [/(\d{1})(\d{3})(\d{0,3})(\d{0,4})/g, '$1 ($2) $3-$4'],
  CA: [/(\d{3})(\d{0,3})(\d{0,4})/g, '$1-$2-$3'],
  CA1: [/(\d{1})(\d{3})(\d{0,3})(\d{0,4})/g, '$1 ($2) $3-$4']
}

export default PhoneNumberFormats
